// Microsoft Entra ID (Azure AD) Configuration
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID || "7c6b3de5-9446-4368-960a-8613e53e209a",
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_MSAL_TENANT_ID || "2da0b43a-b8f0-45ed-8716-4fdeecec40fe"}`,
    redirectUri: process.env.REACT_APP_REDIRECT_URI || "https://teletech.therapymgmt.com/callback",
    postLogoutRedirectUri: process.env.REACT_APP_POST_LOGOUT_URI || "https://teletech.therapymgmt.com/login",
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};
